class WComparison extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.scroll = this.querySelector('[data-scroll]');
    this.nextBtn = this.querySelector('[data-scroll-next]');
    this.button = this.querySelector('.w-comparison__button');

    this.button?.addEventListener('click', (event) => {
      if (this.button.hasAttribute('data-w-drawer-open')) return;
      const href = this.button.getAttribute('href') || '';
      const id = href.includes('#') ? href.slice(href.indexOf('#') + 1) : '';
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, { signal });

    if (this.scroll && this.nextBtn) {
      const colWidth = () => {
        const cell = this.scroll.querySelector('.w-comparison__cell');
        return cell ? Math.round(cell.getBoundingClientRect().width) : 116;
      };
      const maxScroll = () => this.scroll.scrollWidth - this.scroll.clientWidth;

      this.nextBtn.addEventListener('click', () => {
        const step = Math.max(colWidth(), this.scroll.clientWidth - colWidth());
        if (this.scroll.scrollLeft >= maxScroll() - 4) {
          this.scroll.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scroll.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, { signal });

      const update = () => {
        this.nextBtn.hidden = maxScroll() <= 4;
      };
      this.scroll.addEventListener('scroll', update, { signal, passive: true });
      window.addEventListener('resize', update, { signal });
      update();
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.define('w-comparison', WComparison);
